import { styled } from '@mui/material';

export const CanvasFlexWrapper = styled('div')`
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
`;
